import { useCallback } from 'react';

import { useEstateWaterfallContext } from '../contexts/estateWaterfall.context';
import { ManageGroupFormShape } from './ManageGroupModal';

interface UseManageNodeGroupProps {
  groupId: string;
  nodeId: string;
}

/**
 * Manage node group via local state only (no GraphQL mutations).
 * All changes are batched and persisted on Save.
 */
export function useManageNodeGroup({
  groupId,
  nodeId,
}: UseManageNodeGroupProps) {
  const { dispatch } = useEstateWaterfallContext();

  const saveManageNodeGroup = useCallback(
    async (formData: ManageGroupFormShape) => {
      const nodeIds = formData.nodes.map((n) => n.id);

      if (nodeIds.length < 2) {
        // Delete the group if the group has been reduced to less than 2 nodes
        dispatch({
          type: 'DELETE_NODE_GROUP',
          groupId,
        });
        return undefined;
      }

      // Update the group via local state
      dispatch({
        type: 'UPDATE_NODE_GROUP',
        groupId,
        displayName: formData.displayName ?? '',
        description: formData.description ?? undefined,
        namespace: formData.namespace ?? '',
        nodeIds,
        applyToAllSections: formData.applyToAllSections ?? false,
        componentType: formData.componentType,
        hideGroupContents: formData.hideGroupContents,
        nodeId,
      });

      // Return undefined since we don't have updated waterfall data from the server
      return undefined;
    },
    [dispatch, groupId, nodeId]
  );

  return { saveManageNodeGroup };
}
